import { useMemo } from 'react'
import SvgCheck from '#/assets/images/icons/check_circle.svg'
import { features } from '#/consts/plan'
import styles from '../styles.module.scss'

interface PlanCardProps {
  color: string
  role: TopHap.UserRole
  infoComponent: React.ReactElement
}

export default function PlanCard({
  color,
  role,
  infoComponent
}: PlanCardProps) {
  const items = useMemo(() => {
    let items: any[] = []
    features.forEach(e => {
      items = [
        ...items,
        ...e.items.filter(item =>
          (role === 'basic' ? ['free', 'basic'] : [role]).includes(
            item.requireRole
          ))
      ]
    })

    return items
  }, [features])

  return (
    <div className={styles['th-plan-card']}>
      {infoComponent}
      <ul>
        {items.map((item, index) => (
          <div key={index} className={styles['th-plan-feature']}>
            <SvgCheck style={{ color }} />
            {item.title}
          </div>
        ))}
      </ul>
    </div>
  )
}
